<template>
  <div>
    <!-- start: page -->
    <form class="ecommerce-form action-buttons-fixed" @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">{{ translations.townDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.townDetailsInfo }}
                  </p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.town.title.$invalid && $v.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naziv</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="town.title"
                      />

                      <form-error :model="$v.town.title" :dirty="$v.$dirty" label="Naziv"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.town.zipCode.$invalid && $v.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Zip kôd</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Zip kôd"
                        v-model="town.zipCode"
                      />
                      <form-error :model="$v.town.zipCode" :dirty="$v.$dirty" label="Zip kôd"/>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3" :class="{ 'has-danger': $v.town.dialingCode.$invalid && $v.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Pozivni broj</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Pozivni broj"
                        v-model="town.dialingCode"
                      />
                      <form-error :model="$v.town.dialingCode" :dirty="$v.$dirty" label="Pozivni broj"/>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center pb-3"
                    :class="{ 'has-danger': $v.town.countryId.$invalid && $v.$dirty }">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Država</label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="town.countryId">
                        <option :value="null">Izaberite državu</option>
                        <option :value="country.id" :key="country.id" v-for="country in countries">{{ country.title }}</option>
                      </select>

                      <form-error :model="$v.town.countryId" :dirty="$v.$dirty" label="Država"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link exact :to="{ name: 'Towns' }" class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3">
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="
              submit-button
              btn btn-primary btn-px-4
              py-3
              d-flex
              align-items-center
              font-weight-semibold
              line-height-1
            "
            data-loading-text="Loading..."
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteTown }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="deleteTown" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import api from '@/services/api';
import FormError from '../shared/form-errors/FormError';
import Modal from '../shared/modal/Modal';

export default {
  name: 'EditTown',
  mixins: [translations],
  components: { FormError, Modal },
  validations: {
    town: {
      ...validations,
    },
  },
  computed: {
    modalText() {
      return this.translations.areYouSureTown.replace('{town}', `<strong>${this.town.title}</strong>`);
    },
    town() {
      return this.$store.getters.getTown;
    },
    countries() {
      return this.$store.getters.getCountries;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
  },
  mounted() {
    this.$store.dispatch('getTown', this.$route.params.id);
    this.$store.dispatch('getCountries', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      const { town } = this;

      api.updateTown(town)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Towns' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    deleteTown() {
      api
        .deleteTowns([this.town.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Towns' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: 'Towns' });
        });
    },
  },
};
</script>